/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { IdentityApiConfiguration as __Configuration } from '../identity-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ServiceViewModel } from '../models/service-view-model';
@Injectable({
  providedIn: 'root',
})
class GatewayServiceService extends __BaseService {
  static readonly GetPath = '/api/service';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @return Success
   */
  GetResponse(): __Observable<__StrictHttpResponse<Array<ServiceViewModel>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/service`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ServiceViewModel>>;
      })
    );
  }
  /**
   * @return Success
   */
  Get(): __Observable<Array<ServiceViewModel>> {
    return this.GetResponse().pipe(
      __map(_r => _r.body as Array<ServiceViewModel>)
    );
  }
}

module GatewayServiceService {
}

export { GatewayServiceService }
